import type { FaireProductEntity } from "../../entity_types/product";

export const p_d6e69rjt4e: FaireProductEntity = {
  token: "p_d6e69rjt4e",
  type: "product",
  name: "Mini Zen Garden Kit for Relaxation",
  brandToken: "b_qqbr958t4u",
  brandName: "My Wholesale Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/236b957c6856d035f0bb09be753b45dc3732f3532c58a2469e5b0b421cf6ad09.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af289e64f10c2efcd77c29225cd4d178ee238ad35b0cbd88bff09d0e9f46bdd1.jpeg",
    "https://cdn.faire.com/fastly/d473fe03d70c88a0a6eb6ea70440bb6f8a8690fb08d2cedf0fcdc015c82bfe84.jpeg",
    "https://cdn.faire.com/fastly/9883440d075fc4f4e3c9545ed9b28ee314a42c4fafa63c173b3f6c019a0346bb.jpeg",
  ],
  priceDollars: 22.86,
  description:
    "Transform your space into a serene oasis with our premium Tabletop Zen Garden Kit. Perfect for stress relief and meditation, this kit includes everything you need to create a calming miniature landscape right on your desk or coffee table. Featuring high-quality sand, smooth stones, a handcrafted wooden rake, and a selection of decorative elements, our Zen garden kit allows you to design and redesign your personal sanctuary. Ideal for home or office use, this kit promotes relaxation and enhances focus, making it an excellent gift for mindfulness enthusiasts. Discover tranquility and boost your well-being with our Tabletop Zen Garden Kit today.\n• This home decor weighs 1.5 lbs. And measures 7 inches by 6.25 inches by 2.25 inches.\n• Made of wood, stone, cement, sand, and plastic to create a beautifully detailed sculpture.\n• Class up your home with this exquisite piece! Place on your fireplace mantel, a shelf, or a tabletop surface to as a stylish and sophisticated display model.\n• To clean your d&eacute;cor, dust lightly or wipe with a damp cloth as needed.\n• Enjoy your own private Zen garden, even if you're short on space! Nifty tabletop box contains every essential- sand, rocks, candleholder and rake- to create a serenely scenic escape from the everyday.",
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:50.008Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
